import BusParametersDataView from '@utmb/types/view/BusParametersDataView';
import SelectableBusPassView from '@utmb/types/view/SelectableBusPassView';
export interface DetailPaymentBusPass {
    adultPrice: number;
    adultTheoricalPrice: number;
    busPassId: number;
    childrenPrice: number;
}
export interface DetailPaymentFullBus {
    discountAmount: number;
    discountPassNumber: number;
    discountPercent: number;
    finalPrice: number;
    passDetails: DetailPaymentBusPass[];
    theoricalFinalPrice: number;
}

export const getBusAmountDetail = (
    selectedBusInformation: SelectableBusPassView[],
    busParams: BusParametersDataView,
    nbA: number,
    nbR: number
): DetailPaymentFullBus | undefined => {
    const nbPassForDiscount = selectedBusInformation.filter((pass) => pass.price >= (busParams.minPriceForDiscount ?? 0)).length;

    if (selectedBusInformation && selectedBusInformation.length > 0) {
        const passDetails = selectedBusInformation.map((pass) => {
            const minPrice = pass?.priceFor5
                ? pass.priceFor5 / 5
                : pass.priceFor4
                ? pass.priceFor4 / 4
                : pass.priceFor3
                ? pass.priceFor3 / 3
                : pass.priceFor2
                ? pass.priceFor2 / 2
                : pass.price ?? 0;
            const maxNba = pass.priceFor5 ? 5 : pass.priceFor4 ? 4 : pass.priceFor3 ? 3 : pass.priceFor2 ? 2 : 1;
            const passDetail: DetailPaymentBusPass = {
                adultPrice: 0,
                adultTheoricalPrice: nbA * pass.price,
                childrenPrice: nbR * pass.reducedPrice,
                busPassId: pass.id,
            };

            if (nbA >= maxNba) {
                passDetail.adultPrice = Math.round(100 * nbA * minPrice) / 100;
            } else if (nbA === 4 && pass.priceFor4) {
                passDetail.adultPrice = Math.round(100 * pass.priceFor4) / 100;
            } else if (nbA === 3 && pass.priceFor3) {
                passDetail.adultPrice = Math.round(100 * pass.priceFor3) / 100;
            } else if (nbA === 2 && pass.priceFor2) {
                passDetail.adultPrice = Math.round(100 * pass.priceFor2) / 100;
            } else {
                passDetail.adultPrice = Math.round(100 * pass.price) / 100;
            }

            return passDetail;
        });

        const theoricalFinalPrice = passDetails.reduce((amount, pass) => amount + pass.adultPrice + pass.childrenPrice, 0.0);
        let discountAmount = 0.0;
        let discountPercent = 0;
        let discountPassNumber = 0;

        if (busParams.discount5Pass && nbPassForDiscount >= 5) {
            discountPercent = busParams.discount5Pass;
            discountPassNumber = 5;
            discountAmount = Math.round(100.0 * theoricalFinalPrice * busParams.discount5Pass) / 10000;
        } else if (busParams.discount4Pass && nbPassForDiscount >= 4) {
            discountPercent = busParams.discount4Pass;
            discountPassNumber = 4;
            discountAmount = Math.round(100.0 * theoricalFinalPrice * busParams.discount4Pass) / 10000;
        } else if (busParams.discount3Pass && nbPassForDiscount >= 3) {
            discountPercent = busParams.discount3Pass;
            discountPassNumber = 3;
            discountAmount = Math.round(100.0 * theoricalFinalPrice * busParams.discount3Pass) / 10000;
        } else if (busParams.discount2Pass && nbPassForDiscount >= 2) {
            discountPercent = busParams.discount2Pass;
            discountPassNumber = 2;
            discountAmount = Math.round(100.0 * theoricalFinalPrice * busParams.discount2Pass) / 10000;
        }

        const finalPrice = Math.round(100 * (theoricalFinalPrice - discountAmount)) / 100;

        return {
            passDetails,
            theoricalFinalPrice,
            discountAmount,
            discountPassNumber,
            discountPercent,
            finalPrice,
        };
    }
};
